import { RootState } from "../rootReducer"

export const selectLocation = (state: RootState) => state.router.location
export const selectPathname = (state: RootState) => state.router.location.pathname
export const selectSearch = (state: RootState) => state.router.location.search
